import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBOXouaVus1bq6OTCMIOrjLRG4z19i7_K0",
  authDomain: "manaconnect-9876.firebaseapp.com",
  projectId: "manaconnect-9876",
  storageBucket: "manaconnect-9876.firebasestorage.app",
  messagingSenderId: "58107183076",
  appId: "1:58107183076:web:84738e37bd32f7779ed1f1"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export default app;
